import React from "react";
import CheckBox from "@components/checkBox";
import { usePendingPrefill, useSetDefaultValue } from "@hooks";
import PropTypes from "prop-types";
import environmentSettings from "@src/constants/environmentSettings";
import ConsentHeading from "./consentHeading.styles";

export default function MarketingConsentCheckbox({ ...props }) {
  const { companyName } = environmentSettings;

  const { setFieldValue, name, ...checkboxProps } = props;
  useSetDefaultValue(name, false);
  usePendingPrefill(name);

  return (
    <div>
      <ConsentHeading><strong>Optional Consents</strong></ConsentHeading>
      <ConsentHeading>You consent to:</ConsentHeading>
      <label>
        <CheckBox {...checkboxProps} name={name}>
          <ul><strong>Receiving marketing communications</strong> from {companyName}, including updates and promotions about our credit products and services and acknowledge that you can unsubscribe at any time.
          </ul>
        </CheckBox>
      </label>
    </div>
  );
}

MarketingConsentCheckbox.propTypes = {
  setFieldValue: PropTypes.func,
  name: PropTypes.string,
};
